var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMdiMagic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.3752 7L6.2502 8.75L8.0002 5.625L6.2502 2.5L9.3752 4.25L12.5002 2.5L10.7502 5.625L12.5002 8.75L9.3752 7ZM24.3752 19.25L27.5002 17.5L25.7502 20.625L27.5002 23.75L24.3752 22L21.2502 23.75L23.0002 20.625L21.2502 17.5L24.3752 19.25ZM27.5002 2.5L25.7502 5.625L27.5002 8.75L24.3752 7L21.2502 8.75L23.0002 5.625L21.2502 2.5L24.3752 4.25L27.5002 2.5ZM16.6752 15.975L19.7252 12.925L17.0752 10.275L14.0252 13.325L16.6752 15.975ZM17.9627 9.1125L20.8877 12.0375C21.3752 12.5 21.3752 13.3125 20.8877 13.8L6.3002 28.3875C5.8127 28.875 5.0002 28.875 4.5377 28.3875L1.6127 25.4625C1.1252 25 1.1252 24.1875 1.6127 23.7L16.2002 9.1125C16.6877 8.625 17.5002 8.625 17.9627 9.1125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdiMagic);
export default __webpack_public_path__ + "static/media/mdi_magic.736faa1f853543ffa8ea51005a6f7cf3.svg";
export { ForwardRef as ReactComponent };